// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image__wrapper[data-v-f37ab350]{position:relative}.image__overlay[data-v-f37ab350]{bottom:0;left:0;right:0}.image__overlay[data-v-f37ab350],.image__overlay__error[data-v-f37ab350]{position:absolute;top:0}.image__preview--error[data-v-f37ab350]{filter:brightness(.5) blur(5px) grayscale(1) contrast(.5)}.image--round[data-v-f37ab350],.image__preview--round[data-v-f37ab350]{border-radius:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
